<template lang="pug">
div.padding
    span._300.block.text-md
        p.m-b-md Integrations

    div.clearfix

    .text-lg.text-center
        v-loading(loader="fetch-providers")

    div.row
        div(class="col-xs-6 col-sm-6 col-md-3", v-for="provider in providers")
            div.box.p-a-sm.text-center
                img(:src="provider.image_url", class="w-sm")
                div.p-a-sm
                    div {{ provider.description }}

                    p.m-t-md.text-center(v-if="isConnected(provider) && provider.name == 'slurp'")
                        span.clear Connected Franchise
                        span._600 {{ provider.connected.name }}

                    p.m-t-md(v-if="canManage")
                        a(:href="provider.auth_url", class="btn btn-outline b-primary text-primary", v-if="!isConnected(provider)") Connect
                        a(class="btn btn-fw danger", v-else, @click="disconnectProvider(provider)") Disconnect

                        a(
                            class="btn btn-outline b-dark text-dark m-l-sm",
                            v-if="isConnected(provider)",
                            @click="showIntegrationItems(provider)"
                        ) Import

    integrations-item(:provider="provider", ref="integrationItems", v-if="provider !== null")
</template>

<script>
import integrationsItem from './integrations-item.vue';
import mixins from '@js/mixins/';
import { Event } from '@js/event-bus';
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
    components: {
        integrationsItem,
    },
    mixins: [mixins],

    computed: {
        ...mapGetters('provider', ['getProviderByName']),

        ...mapState('provider', [
            'providers',
            'provider',
            'importItems',
            'integrationProcessing',
        ]),

        ...mapState('socket', ['laravelEcho']),

        canManage() {
            return this.can(this.permission.SAVE_INTEGRATION);
        },
    },

    created() {
        this.initSocket();

        this.getProviders();

        this.laravelEcho
            .private(`user.${this.authUser.id}`)
            .listen('.item_synced', payload => {
                if (payload.provider == this.provider.name) {
                    let items = this.importItems.filter(
                        item => item != payload.item,
                    );
                    this.setImportItems(items);

                    if (
                        !this.importItems.length &&
                        this.integrationProcessing
                    ) {
                        this.setIntegrationProcessing(false);
                        this.getProviders();
                        this.swal();
                        this.toogleModal('hide');
                        this.$refs.integrationItems.items = [];
                    }
                }
            });
    },

    methods: {
        toogleModal(action) {
            $('#integration-items').modal(action);
        },

        showIntegrationItems(provider) {
            this.setProvider(provider);

            setTimeout(() => {
                this.toogleModal('show');
            }, 100);
        },

        disconnectProvider(provider) {
            const url = Laroute.route(
                'settings.integrations.disconnect_provider',
                {
                    provider_name: provider.name,
                },
            );

            this.swalAjaxConfirmation({
                text: `Disconnect will disable integration between inventory and ${
                    provider.display_name
                }`,
                url,
                type: 'warning',
                method: 'delete',
                confirmButtonText: 'Disconnect',
                onSuccess: () => {
                    this.swal();
                    this.getProviders();
                },
            });
        },

        isConnected(provider) {
            return provider.connected !== null;
        },

        ...mapActions('provider', [
            'getProviders',
            'setImportItems',
            'setProvider',
            'setIntegrationProcessing',
        ]),

        ...mapActions('socket', ['initSocket']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/integration/integration-list.vue